import { SlidersHorizontal } from 'lucide-react';
import { Button } from '~/components/ui/button';

interface FiltersButtonProps {
  /** Active filter count; a brand bubble shows it when above zero. It comes from the applied filters, so it drops only once a clear has taken effect. */
  count?: number;
  onClick: () => void;
  /** Shown beside the button while any filter is active (DESIGN.md §4.5). */
  onClear?: () => void;
  testId?: string;
}

/** A list toolbar's filter-drawer trigger, beside its `SearchBar` in the card header. */
export function FiltersButton({ count = 0, onClick, onClear, testId }: FiltersButtonProps) {
  return (
    <>
      <Button
        variant="outline"
        onClick={onClick}
        className="relative"
        startIcon={<SlidersHorizontal className="size-4" aria-hidden="true" />}
        testId={testId}
      >
        Filters
        {count > 0 && (
          <span className="absolute -top-1 -right-1 flex size-5 items-center justify-center rounded-full bg-brand-500 text-xs font-semibold text-white">
            <span aria-hidden="true">{count}</span>
            <span className="sr-only">
              {count} active {count === 1 ? 'filter' : 'filters'}
            </span>
          </span>
        )}
      </Button>
      {count > 0 && onClear && (
        <Button variant="outline" onClick={onClear} testId={testId ? `${testId}-clear` : undefined}>
          Clear filters
        </Button>
      )}
    </>
  );
}
